// extracted by mini-css-extract-plugin
export var centerText = "_cu-8";
export var container = "_cu-0";
export var doughnutContainer = "_cu-7";
export var legend = "_cu-a";
export var legendItemColorDisplay = "_cu-b";
export var legendItemLabel = "_cu-d";
export var legendItemValue = "_cu-c";
export var lg = "_cu-5";
export var maxWidth = "_cu-9";
export var md = "_cu-4";
export var responsive = "_cu-6";
export var sm = "_cu-3";
export var xs = "_cu-2";
export var xxs = "_cu-1";